// Reconstructed from the supplied production build; original component names were unavailable.
import "./styles/site.css";
import "./styles/tinytodds-theme.css";
import { React, ReactDOM } from "./vendor/runtime.js";
import { App } from "./App.jsx";
ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
